import { Timestamp } from 'firebase/firestore';
import { INTEGRATION_FIELDS } from './integrazione';

export const INVII_ROOT_FIELDS = Object.freeze([
  'phone', 'dataConsegna', 'rowColor', 'notes', 'noteAlimentazione', 'noteAllenamento',
]);
const PROGRAM_FIELDS = new Set([
  'allenamento', 'kcalalimentazioni', 'strategia', 'freqallenamento', 'nota1',
  'nutrizionista', 'videocall', 'nutrizionistadiet', 'noteselect', 'noteinterna',
  'dataCreazione', 'percorsoId', 'consegnaConfirmed', 'consegnaConfirmedAt',
  'progCustomizzato', 'progCustomizzatoAt',
]);
const DATE_FIELDS = new Set(['dataConsegna', 'dataCreazione', 'consegnaConfirmedAt', 'progCustomizzatoAt']);
const BOOLEAN_FIELDS = new Set(['consegnaConfirmed', 'progCustomizzato']);
const NUMERIC_FIELDS = new Set(['kcalalimentazioni', 'freqallenamento']);
const FORBIDDEN_KEYS = new Set([
  ...INTEGRATION_FIELDS, '__proto__', 'constructor', 'prototype', 'id', 'uid', 'userId', 'userRole', 'alimentazioni',
]);
const isRecord = (value) => value !== null && typeof value === 'object'
  && [Object.prototype, null].includes(Object.getPrototypeOf(value));

function snapshotField(field, value) {
  if (value === null || value === '') return value;
  if (DATE_FIELDS.has(field)) {
    if (value instanceof Timestamp) return new Timestamp(value.seconds, value.nanoseconds);
    if (value instanceof Date && Number.isFinite(value.getTime())) return new Date(value.getTime());
    if ((typeof value === 'string' || typeof value === 'number') && Number.isFinite(new Date(value).getTime())) return value;
  } else if (BOOLEAN_FIELDS.has(field)) {
    if (typeof value === 'boolean') return value;
  } else if (typeof value === 'string' || (NUMERIC_FIELDS.has(field) && typeof value === 'number' && Number.isFinite(value))) {
    return value;
  }
  throw new Error(`Valore non valido per il campo ${field}. Le modifiche restano in attesa.`);
}

// Snapshot only editable values, before the first asynchronous step of a save.
// Keep empty strings here so callers can acknowledge precisely the edits saved.
export function snapshotInviiPendingChanges(raw) {
  if (raw == null) return {};
  if (!isRecord(raw)) throw new Error('Modifiche Invii non valide.');
  const snapshot = {};
  for (const [key, value] of Object.entries(raw)) {
    if (INVII_ROOT_FIELDS.includes(key)) {
      snapshot[key] = snapshotField(key, value);
      continue;
    }
    if (!key.trim() || FORBIDDEN_KEYS.has(key) || !isRecord(value)) {
      throw new Error(`Campo o alimentazione non validi: ${key}.`);
    }
    const patch = {};
    for (const [field, fieldValue] of Object.entries(value)) {
      if (!PROGRAM_FIELDS.has(field)) throw new Error(`Campo non modificabile dal salvataggio Invii: ${field}.`);
      patch[field] = snapshotField(field, fieldValue);
    }
    if (Object.keys(patch).length) snapshot[key] = patch;
  }
  return snapshot;
}

export function hasInviiPendingChanges(raw) {
  if (!isRecord(raw)) return false;
  return Object.entries(raw).some(([key, value]) => INVII_ROOT_FIELDS.includes(key)
    || !isRecord(value) || Object.keys(value).length > 0);
}
